var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74401 8.74419C6.64611 8.84198 6.56844 8.95812 6.51545 9.08595C6.46246 9.21378 6.43518 9.35081 6.43518 9.48919C6.43518 9.62757 6.46246 9.76459 6.51545 9.89242C6.56844 10.0203 6.64611 10.1364 6.74401 10.2342L11.291 14.7912C11.3839 14.8843 11.4943 14.9582 11.6157 15.0086C11.7372 15.059 11.8675 15.085 11.999 15.085C12.1305 15.085 12.2608 15.059 12.3823 15.0086C12.5038 14.9582 12.6141 14.8843 12.707 14.7912L17.257 10.2332C17.4543 10.0359 17.5652 9.76824 17.5652 9.48919C17.5652 9.21013 17.4543 8.94251 17.257 8.74519C17.0597 8.54787 16.7921 8.43701 16.513 8.43701C16.234 8.43701 15.9663 8.54787 15.769 8.74519L11.999 12.5212L8.23101 8.74519C8.13341 8.64749 8.0175 8.56999 7.88993 8.51712C7.76236 8.46424 7.62561 8.43703 7.48751 8.43703C7.34942 8.43703 7.21267 8.46424 7.0851 8.51712C6.95752 8.56999 6.84162 8.64749 6.74401 8.74519V8.74419Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.cc9eab3a339c098608e6e36187669330.svg";
export { ForwardRef as ReactComponent };